<script setup lang="ts">
import VarsityContentProcessor from "@/components/VarsityContentProcessor.vue"
const props = defineProps<{
    element: any
}>()
</script>

<template>
    <div class="cms-timeline">
        <div class="cms-timeline-line" :style="{ gridRow: `1 / span ${props.element.columns[0]?.length}` }"></div>
        <div
            v-for="(item, $index) of props.element.columns[0] ?? []"
            class="cms-timeline-item"
            :style="{ gridRow: $index + 1 }"
            :class="item.config.align === 'right' ? 'cms-timeline-item-right' : 'cms-timeline-item-left'"
        >
            <div class="cms-timeline-label" v-if="item.buttonText">
                <div class="btn-primary btn-shape-skewed d-inline-block disabled">{{ item.buttonText }}</div>
            </div>
            <div class="cms-timeline-dot"></div>
            <div class="cms-timeline-content">
                <div class="cms-timeline-content-arrow"></div>
                <div class="my-1 mx-3 flex-grow-1">
                    <div class="fs-1-5 font-weight-bold">
                        <VarsityContentProcessor :content="item.title"></VarsityContentProcessor>
                    </div>
                    <VarsityContentProcessor :content="item.text"></VarsityContentProcessor>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.cms-timeline {
    display: grid;
    grid-template-columns: 1fr 1.25rem 1fr;
    grid-template-rows: auto;
}

.cms-timeline-line {
    background-color: #000;
    width: 2px;
    grid-column: 2 / span 1;
    margin: auto;
    height: 100%;
}

.cms-timeline-item {
    margin: 1rem 0;
    grid-column: 1 / span 3;
    display: grid;
    grid-template-columns: 1fr 1.5rem 1fr;
}

.cms-timeline-content-arrow {
    border-left: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    background-color: #fff;
    width: 1rem;
    height: 1rem;
    transform: rotate(45deg);
    margin-left: -0.1rem;
    margin-top: 1.15rem;
}

.cms-timeline-content {
    grid-row: 1;
    border: 1px solid #ddd;
    background-color: #fff;
    display: flex;
    grid-column: 3;
}

.cms-timeline-dot {
    grid-row: 1;
    grid-column: 2;
    margin-top: 1rem;
    background-color: #000;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 5px;
    transform: rotate(45deg);
}

.cms-timeline-label {
    grid-row: 1;
    margin-left: auto;
    margin-top: 0.5rem;
    margin-right: 0.5rem;
}

.cms-timeline-item-left {
    .cms-timeline-content {
        flex-direction: row-reverse;
        grid-column: 1;
    }

    .cms-timeline-content-arrow {
        transform: rotate(225deg);
        margin-left: 0;
        margin-right: -0.1rem;
    }

    .cms-timeline-label {
        grid-column: 3;
        margin-right: auto;
        margin-top: 0.5rem;
        margin-left: 0.5rem;
    }
}
</style>
